/*eslint quote-props: off*/
const tr = {
    tourImage: {
      attributes: {
        title: 'Imagem do Tour',
        id: 'ID',
        is_active:'Ativo',
        created_at: 'Criado em',
        updated_at: 'Atualizado em',
        name: 'Nome',
        lang: 'Linguagem',
        sorter: 'Ordenação',
        link_url: 'linkUrl',
        image_url: 'imageUrl',
        image: 'Imagem',
        image_id: 'ID da imagem',
        preview: 'Preview',
        image_base64: 'Imagem',
        archive_id: 'Imagem',
      },
      extras: {
        delete_toast: 'Imagem do tour excluída com sucesso!',
        delete_toast_fail: 'Não foi possível excluir a Imagem do Tour',
        tour_image_preview: 'Imagem do tour',
      }
    },
};

export default tr;
